import React, { Fragment } from 'react';
import { Badge, Col, Button, Row, Icon } from 'framework7-react';
import {
  DOC_TYPE_DOCUMENT,
  DOC_TYPE_SIGNATURE,
  /*DOC_TYPE_INFORMATION,
  DOC_TYPE_IMMEDIATE_CONFIRMATION,
  isDocumentSubmitted,*/
  getIcon
} from '../helpers/utils';
import PropTypes from 'prop-types';
import { prepareListInfo } from './Elements';
import InlineQuickForm from '../quickForm/InlineQuickForm';
import II18 from '../translate/II18';

class DesktopDocEntry extends React.Component {
  render = () => {
    const {
      document,
      scannedPages,
      forms,
      documentsStatus,
      scanEnded,
      onDesktopUploadClick,
      successSentKeys,
      errorSentKeys,
      animateEntry
    } = this.props;

    const {
      desctopIcon,
      desctopIconRight,
      desctopTitle,
      documentReady,
      hasScannedPages,
      submitted,
      badge,
      hasProblem,
      rejected
    } = prepareListInfo(
      document,
      scannedPages,
      forms,
      documentsStatus,
      successSentKeys,
      errorSentKeys,
      scanEnded
    );

    const disabledEntry = false;

    return document.inlineMode ? (
      <InlineQuickForm requestedDocumentId={document.id} />
    ) : (
      <Row
        className={
          'desktop-document ' +
          'documentRow_' +
          document.type +
          (animateEntry ? ' pulse ' : '') +
          (disabledEntry ? ' disabled' : '') +
          (rejected ? ' rejected' : '') +
          (submitted ? ' submitted' : '') +
          (documentReady ? ' ready' : '') +
          (hasProblem ? ' doc-problem ' : '')
        }
        style={{ alignItems: 'center' }}
      >
        <Col width="10" style={{ position: 'relative' }}>
          {document.type === DOC_TYPE_DOCUMENT &&
          !submitted &&
          hasScannedPages ? (
            <div
              className="img-wrap"
              data-testid={'loadedDocumentIcon'}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (!disabledEntry) {
                  onDesktopUploadClick(document);
                }
              }}
            >
              <label
                className={'button-badge '}
                data-testid={'loadedDocumentBage'}
                data-testvalue={hasScannedPages}
              >
                {hasScannedPages}
              </label>
              <img alt="Preview" src={scannedPages.values().next().value} />
            </div>
          ) : (
            <Fragment>
              {/*getIcon(desctopIcon, 38)*/}
              {desctopIcon}
              {badge && (
                <label className={'button-badge icon-bage'}>
                  {badge === true ? (
                    <Icon material={'done'} size={20} />
                  ) : (
                    badge
                  )}
                </label>
              )}
            </Fragment>
          )}
        </Col>

        <Col width="60">
          <label
            id={'documentEntryTitle_' + document.id}
            style={{ fontSize: 18, lineHeight: 'initial' }}
          >
            {document.name}
          </label>
          {document.optional ? (
            <Badge
              style={{
                marginLeft: 20,
                fontSize: 10,
                lineHeight: 15
              }}
            >
              optional
            </Badge>
          ) : null}
          {document.hint && (
            <div className="eqx_tooltip">
              <Icon
                material={'info'}
                style={{ marginLeft: 5, color: '#889cb2' }}
                size={20}
              />
              <span className="eqx_tooltiptext">{document.hint}</span>
            </div>
          )}
        </Col>

        <Col width="30" style={{ display: 'flex', justifyContent: 'end' }}>
          {
            <Button
              id={'documentEntryAction_' + document.id}
              fill
              className={`scan-portal documentEntryAction documentEntryAction_${document.type}`}
              onClick={() => {
                if (!disabledEntry) {
                  onDesktopUploadClick(
                    document,
                    document.type === DOC_TYPE_SIGNATURE
                  );
                }
              }}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <label className={'screenreader'}>
                {II18.get(
                  `dialog_required_document_${document.type}`,
                  document.name
                )}
              </label>
              {getIcon(desctopIconRight)}{' '}
              <label style={{ textAlign: 'center', flexGrow: 2 }}>
                {desctopTitle}
              </label>
            </Button>
          }
        </Col>
      </Row>
    );
  };
}

DesktopDocEntry.propTypes = {
  document: PropTypes.object,
  scannedPages: PropTypes.object,
  forms: PropTypes.object,
  documentsStatus: PropTypes.object,
  scanEnded: PropTypes.bool,
  onDesktopUploadClick: PropTypes.func,
  successSentKeys: PropTypes.object,
  errorSentKeys: PropTypes.object,
  animateEntry: PropTypes.bool
};

export default DesktopDocEntry;
